import clsx from 'clsx';

import css from './index.module.css';

type LoaderProps = {
  className?: string;
};

const Loader = ({ className }: LoaderProps) => {
  return (
    <span className={clsx(css['lds-ellipsis'], className)}>
      <span />
      <span />
      <span />
      <span />
    </span>
  );
};

export default Loader;
